/**
 * Test data: list tests from arbitium_tests, threat events by candidate_id.
 */

import { fetchRing } from '../core';
import type { ArbitiumTest, ArbitiumThreatEvent } from '../../types/tests';

const RING_TESTS = 'arbitium_tests';
const RING_THREAT_EVENTS = 'arbitium_threat_events';

/**
 * Fetches all test runs from arbitium_tests ring (paginated).
 */
export async function getTestData(options?: { limit?: number }): Promise<ArbitiumTest[]> {
  const limit = options?.limit ?? 250;
  const all: ArbitiumTest[] = [];
  let lastkey: string | undefined;
  for (;;) {
    const res = await fetchRing<ArbitiumTest>(RING_TESTS, { limit, lastkey });
    const items = Array.isArray(res.items) ? res.items : [];
    all.push(...items);
    lastkey = res.last_id;
    if (!lastkey || items.length < limit) break;
  }
  return all;
}

/**
 * Fetches threat events from arbitium_threat_events ring (single page).
 */
export async function getThreatEventsList(limit = 500): Promise<ArbitiumThreatEvent[]> {
  const res = await fetchRing<ArbitiumThreatEvent>(RING_THREAT_EVENTS, { limit });
  return Array.isArray(res.items) ? res.items : [];
}

/**
 * Returns threat event(s) linked to a test by candidate_id.
 */
export async function getThreatEventsByCandidateId(
  candidateId: string
): Promise<ArbitiumThreatEvent[]> {
  if (!candidateId.trim()) return [];
  const events = await getThreatEventsList();
  return events.filter((e) => (e.candidate_id || '').trim() === candidateId.trim());
}
